
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Image from "../assets/images/Hfp-Logo-Photoroom.png";
import homefitMobileLogo from "../assets/images/mobile-logo.png";
import Footer from "./Footer";
import { IoMenu, IoClose } from "react-icons/io5";
import { IoChevronUp } from "react-icons/io5";
import axios from "axios";
import "./privacyPolicy.css";
import ClipLoader from "react-spinners/ClipLoader";

const PrivacyPolicy = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const sidebarRef = useRef(null);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const headerRef = useRef(null);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentLogo, setCurrentLogo] = useState(Image);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      const api_url = process.env.REACT_APP_API_URL;
      try {
        // const response = await axios.post(
        //   "http://lsdemoserver.com:7772/api/admin/getCmsById",
        //   {
        //     id: "65c09efad84872e40417e20e",
        //   }
        // );
            const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/admin/getCmsById`,
          {
            id: "65c09efad84872e40417e20e",
          }
        );
        const { description } = response.data.data;
        setDescription(description);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowSidebar(false);
      }
    };

    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSidebar]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 500 && width >= 200) {
        setCurrentLogo(homefitMobileLogo);
      } else {
        setCurrentLogo(Image);
      }
      setIsLargeScreen(width >= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleScroll = () => {
    if (headerRef.current) {
      if (window.scrollY > 200) {
        headerRef.current.classList.add("shadow-lg");
      } else {
        headerRef.current.classList.remove("shadow-lg");
      }
    }
    if (window.scrollY > 200) {
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="px-8 lg:px-32 xl:px-52 bg-white ">
        <header
          ref={headerRef}
          className={`text-black z-10 bg-white ${
            isLargeScreen ? "" : "fixed top-0 left-0 right-0 w-full"
          }`}
          style={{ width: "100%" }}
        >
          <div className="container mx-auto flex items-center justify-between h-[80px]">
            <div className="flex items-center justify-center mb-2">
              <Link to="/">
                <img
                  src={currentLogo}
                  alt="Icon"
                  className={`privacy-policy-logo w-[150px] cursor-pointer ${
                    currentLogo === homefitMobileLogo
                      ? "w-[165px] h-auto "
                      : "w-[170px] h-auto "
                  }`}
                />
              </Link>
            </div>

            {/* Mobile Menu Icon */}
            {!isLargeScreen && (
              <div className="flex items-center absolute top-0 right-0 p-4 z-10">
                <button onClick={() => setShowSidebar(true)}>
                  <IoMenu size={30} className="text-black" />
                </button>
              </div>
            )}

            {/* Desktop Menu */}
            {isLargeScreen && (
              <nav className="hidden md:flex flex-col md:flex-row" key="nav">
                <Link
                  to="/"
                  className="mx-4 mb-2 md:mb-0 font-body font-semibold hover:text-[#f16c7d] mt-2"
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    textDecoration: "none",
                  }}
                >
                  Home
                </Link>
                <Link
                  to="/privacy-policy"
                  className="mx-4 mb-2 md:mb-0 font-body font-semibold hover:text-[#f16c7d] mt-2"
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    textDecoration: "none",
                  }}
                >
                  Privacy Policy
                </Link>
              </nav>
            )}
          </div>
        </header>

        {/* Mobile Sidebar Menu */}
        {showSidebar && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
            <div
              ref={sidebarRef}
              className="fixed top-0 right-0 h-full bg-white shadow-lg p-4"
              style={{ width: "300px" }}
            >
              <button
                onClick={() => setShowSidebar(false)}
                className="absolute top-4 right-4"
              >
                <IoClose size={30} className="text-black" />
              </button>
              <nav className="flex flex-col space-y-4 mt-10">
                <Link
                  to="/"
                  className="text-lg font-semibold hover:text-[#f16c7d] text-left border-b border-gray-300 pb-2"
                  onClick={() => setShowSidebar(false)}
                >
                  Home
                </Link>
                <Link
                  to="/privacy-policy"
                  className="text-lg font-semibold hover:text-[#f16c7d] text-left border-b border-gray-300 pb-2"
                  onClick={() => setShowSidebar(false)}
                >
                  Privacy Policy
                </Link>
              </nav>
            </div>
          </div>
        )}
      </div>

      {/* Main Content - Updated with reference code structure */}
      <div className="privacy-policy-container mx-auto lg:px-[72px] xl:px-[190px] 2xl:px-[270px] bg-[#ffffff]">
        <div className="w-full h-auto flex justify-center items-center pt-20 md:pt-0">
          <div className="container mx-auto px-2 py-8 text-justify text-[15px]">
            <h1 className="text-4xl font-extrabold text-center mb-3">
              Privacy Policy
            </h1>
            <br />
            
            {loading ? (
              <div className="flex justify-center items-center h-screen">
                <ClipLoader color="#f16c7d" size={40} />
              </div>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: description }} />
            )}
            
            {error && <div>Error: {error}</div>}
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollToTop && (
        <button
          onClick={scrollToTop}
          className="rounded-scroll-to-top"
          aria-label="Scroll to top"
        >
          <IoChevronUp size={24} />
        </button>
      )}

      <div className="bg-[#eeeeee]">
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;